"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOStateProvider = exports.useIOState = exports.KeyboardActions = void 0;
const unstated_next_1 = require("unstated-next");
const react_1 = require("react");
var KeyboardActions;
(function (KeyboardActions) {
    KeyboardActions["Delete"] = "Delete";
    KeyboardActions["Undo"] = "Undo";
    KeyboardActions["Redo"] = "Redo";
    KeyboardActions["Save"] = "Save";
})(KeyboardActions = exports.KeyboardActions || (exports.KeyboardActions = {}));
const useIOStateContainer = unstated_next_1.createContainer(() => {
    const [actions, setActions] = react_1.useState({});
    const on = (action) => {
        var _a;
        (_a = actions[action]) === null || _a === void 0 ? void 0 : _a.call(actions);
    };
    react_1.useEffect(() => {
        const handleKeyboard = (event) => {
            const ctrl = event.ctrlKey || event.metaKey;
            if (event.key === 'm') {
            }
            if (event.key === 'Delete') {
                on(KeyboardActions.Delete);
            }
            if (event.key === 'Backspace') {
                on(KeyboardActions.Delete);
            }
            if (event.key === 'z' && ctrl && !event.shiftKey) {
                on(KeyboardActions.Undo);
            }
            if (event.key === 'z' && ctrl && event.shiftKey) {
                on(KeyboardActions.Redo);
            }
            if (event.key === 's' && ctrl) {
                event.preventDefault();
                on(KeyboardActions.Save);
            }
        };
        document.addEventListener('keydown', handleKeyboard);
        return () => {
            document.removeEventListener('keydown', handleKeyboard);
        };
    }, [actions]);
    return {
        setActions,
    };
});
exports.useIOState = useIOStateContainer.useContainer;
exports.IOStateProvider = useIOStateContainer.Provider;
